import React from "react";
import projectlist from "../assets/projects/projects.json";
import { Link } from "react-router-dom";

export default function Projects() {
  const projects = projectlist.data;
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center"></div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Project Type
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Framework
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Release Date
                    </th>
                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">View</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {projects.map((project, index) => (
                    <tr key={project.email + "TR" + index}>
                      <td
                        key={project.name}
                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        {project.name}
                      </td>
                      <td
                        key={project.app_type + index}
                        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {project.app_type}
                      </td>
                      <td
                        key={project.app_build_with + index}
                        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {project.app_built_with}
                      </td>
                      <td
                        key={project.project_date + index}
                        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {project.project_date}
                      </td>
                      <td
                        key={project.name + index + "view"}
                        className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                      >
                        <Link
                          as="a"
                          to={`/projects/${project.id}`}
                          key={project.name + index + "url"}
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          View Project
                          <span
                            key={project.name + index + "span"}
                            className="sr-only"
                          >
                            , {project.name}
                          </span>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
